import {RETRIEVE_PARENT_LIST} from '@/api'
import {CREATE_PARENT} from '@/api'
import {GET_PARENT_INFO} from '@/api'
import {EDIT_PARENT} from '@/api'
import {DELETE_PARENT} from '@/api'
import {SEND_MAIL_PARENT} from '@/api'
import {SEND_MAIL_ALL_PARENT} from '@/api'
import {EXPORT_PARENTS} from '@/api'
import {SEND_QR_PARENT} from '@/api'
import {SEND_MAIL_AGENT_ALL_PARENT} from '@/api'
import {SEND_MAIL_AGENT_PERSON_PARENT} from '@/api'
import {
  DETAIL_APPROVE_STUDENT,
  GET_LIST_APPROVE_STUDENT,
  GET_LIST_PARENT_APPROVE,
  REJECT_PARENT_USER,
  UPDATE_APPROVE_STUDENT,
  REJECT_STUDENT,
  SENT_EMAIL_INFO_STUDENT
} from '@/api/phase2/parentApprove'

export default {
  retrieveParentList(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_PARENT_LIST(payload, successCallback, errorCallback)
  },

  createParent({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.parent_info) {
        commit('addParentToList', {parentInfo: response.data.data.parent_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    CREATE_PARENT({data: payload.data}, successCallback, errorCallback)
  },

  editParent({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response) {
        // commit('getParentInfo', {parentInfo: response.data.data.parentInfo})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    EDIT_PARENT({data: payload}, successCallback, errorCallback)
  },

  getParentInfo({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.parent_info) {
        commit('getParentInfo', {parentInfo: response.data.data.parent_info})
      }
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_PARENT_INFO({payload}, successCallback, errorCallback)
  },

  deleteParent(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = () => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_PARENT({payload}, successCallback, errorCallback)
  },

  sendMail(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = () => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    SEND_MAIL_PARENT({payload}, successCallback, errorCallback)
  },

  sendQR(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = () => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    SEND_QR_PARENT({payload}, successCallback, errorCallback)
  },

  sendMailAll(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = () => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    SEND_MAIL_ALL_PARENT({payload}, successCallback, errorCallback)
  },

  sendMailAgentAll(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = () => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    SEND_MAIL_AGENT_ALL_PARENT({payload}, successCallback, errorCallback)
  },

  sendMailAgentPerson(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = () => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    SEND_MAIL_AGENT_PERSON_PARENT(payload, successCallback, errorCallback)
  },

  exportParents(state, payload) {
    let errorCallback = null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    EXPORT_PARENTS(successCallback, errorCallback)
  },
  getListParentApprove ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_LIST_PARENT_APPROVE({ payload }, successCallback, errorCallback)
  },

  rejectParentUser ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    REJECT_PARENT_USER({ payload }, successCallback, errorCallback)
  },

  getListStudentWaitApprove ({commit}, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    GET_LIST_APPROVE_STUDENT({ payload },successCallback, errorCallback)
  },

  updateApproveStudent ({commit}, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    UPDATE_APPROVE_STUDENT({ payload },successCallback, errorCallback)
  },

  getDetailApproveStudent ({commit}, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    DETAIL_APPROVE_STUDENT({ payload },successCallback, errorCallback)
  },
  rejectStudent ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    REJECT_STUDENT({ payload }, successCallback, errorCallback)
  },
  sendEmailInfoStudent ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    SENT_EMAIL_INFO_STUDENT({ payload }, successCallback, errorCallback)
  },

};
